import './color.global.css';
import './root.global.css';
import '@ps-int/mg-theme/src-css/orb-migrate-overrides.css';

export const theme = {
    color: 'orb-migrate-dark',
    root: 'orb-migrate-dark',
};
